import { FunctionComponent, memo } from "react";
import { IProps } from "./phrase-triggers.types";
import { SpinnerUntil } from "@edgetier/components";
import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import { useParams } from "react-router-dom";
import { useTag } from "hooks-for/tags/use-tag";
import PhraseTriggersTable from "./phrase-triggers-table";
import PhraseTriggersInteractionsTagged from "./phrase-triggers-interactions-tagged";
import { Tabs, TabsButton, TabsButtons, TabsItem, TabsItems } from "@edgetier/tabs";
import UsersSubscribed from "./users-subscribed";
import "./phrase-triggers.scss";

/**
 * A page showing all the phrase triggers for a particular tag and users subscribed
 * to that tag.
 */
const PhraseTriggers: FunctionComponent<IProps> = () => {
    const { tagId } = useParams<{ readonly tagId: string | undefined }>();

    // Get tag details
    const { data: tag, isLoading: isTagLoading } = useTag(tagId!, {
        enabled: typeof tagId === "string",
    });

    return (
        <Page className="phrase-triggers">
            <PageHeader
                title={
                    isTagLoading
                        ? "...loading"
                        : typeof tag === "undefined"
                        ? "Phrase Triggers"
                        : `${tag.tagGroup} / ${tag?.tag} / Phrase Triggers`
                }
            />
            <PageContent>
                <SpinnerUntil isReady={!isTagLoading} data={tag}>
                    {typeof tag !== "undefined" && tag !== null ? (
                        <Tabs activeTabId="phrase-triggers">
                            <TabsButtons>
                                <TabsButton tabId="phrase-triggers">Phrase Triggers</TabsButton>
                                <TabsButton tabId="users-subscribed">Users Subscribed</TabsButton>
                            </TabsButtons>
                            <TabsItems>
                                <TabsItem tabId="phrase-triggers">
                                    <PhraseTriggersInteractionsTagged tagId={tag.tagId} />
                                    <PhraseTriggersTable tagId={tag.tagId} />
                                </TabsItem>
                                <TabsItem tabId="users-subscribed">
                                    <UsersSubscribed tagId={tag.tagId} />
                                </TabsItem>
                            </TabsItems>
                        </Tabs>
                    ) : (
                        <div className="phrase-triggers__no-tag-selected">
                            Please select a tag group to view phrase triggers
                        </div>
                    )}
                </SpinnerUntil>
            </PageContent>
        </Page>
    );
};

export default memo(PhraseTriggers);
